/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ClassUtils } from "abweb/utils/ClassUtils";
import { Assert } from "abweb/utils/Assert";
export let Lambdas;
(function (_Lambdas) {
  const identity = _Lambdas.identity = t => t;
  const empty = _Lambdas.empty = () => undefined;
  const not = _Lambdas.not = original => (...args) => !original(...args);
  const makePair = _Lambdas.makePair = (a, b) => [a, b];
  const makeTriple = _Lambdas.makeTriple = (a, b, c) => [a, b, c];
  const isDefined = _Lambdas.isDefined = t => t !== undefined;
  const isNonNull = _Lambdas.isNonNull = t => t !== null;
  const isNonNullish = _Lambdas.isNonNullish = t => isDefined(t) && isNonNull(t);
  const isString = _Lambdas.isString = t => typeof t === "string";
  const isEmpty = _Lambdas.isEmpty = s => s.length === 0;
  const isNotEmpty = _Lambdas.isNotEmpty = s => s.length > 0;
  const isNumber = _Lambdas.isNumber = t => typeof t === "number";
  const ignoringReturnValue = _Lambdas.ignoringReturnValue = originalFuncWithReturnValue => {
    return (...args) => {
      originalFuncWithReturnValue(...args);
    };
  };
  const isInstanceOfClass = _Lambdas.isInstanceOfClass = targetClazz => {
    return o => ClassUtils.isInstanceOf(o, targetClazz);
  };
  const run = _Lambdas.run = runnable => {
    return runnable();
  };
  const distinctBy = _Lambdas.distinctBy = keyExtractor => {
    const seenKeys = new Set();
    return t => {
      const key = keyExtractor(t);
      const isDistinct = !seenKeys.has(key);
      seenKeys.add(key);
      return isDistinct;
    };
  };
  const assertDefined = _Lambdas.assertDefined = (t, message) => {
    Assert.assert(t !== undefined, message);
    return t;
  };
  const assertNonNull = _Lambdas.assertNonNull = (t, message) => {
    Assert.assert(t !== null, message);
    return t;
  };
  const assertNonNullish = _Lambdas.assertNonNullish = (t, message) => {
    Assert.assert(t != null, message);
    return t;
  };
})(Lambdas || (Lambdas = {}));
//# sourceMappingURL=Lambdas.js.map
